/**
 * Landing profile mock for the platform tenant (fields not stored on Space)
 */
export const platformLandingProfile = {
  imageUrl:
    "https://ik.imagekit.io/tercerespacio/tercer-espacio/profile-picture.webp?updatedAt=1749179878529",
  imageAlt: "Logo de Tercer Espacio",
  analyticsPrefix: "landing",
};
